import {
  Card,
  CardContent,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";

const Updates = () => (
  <>
    <Card sx={{ width: 300, marginX: "auto" }}>
      <CardContent>
        <Typography variant="h5">Latest Updates</Typography>
        <Typography variant="subtitle2">v1.5.0</Typography>
      </CardContent>
    </Card>

    <Accordion sx={{ marginTop: 4 }} square={false}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        Updated Deck Lists
      </AccordionSummary>
      <AccordionDetails>
        <Typography align="left">
          Autocompleted rotation decknames have been updated for the "Edge of Paradise" set. If I am missing any rotDecklists, please let me know via twitter. [Link at the bottom of the page] I don't generally play unlimited so it will take a little longer to get those. Thanks for your patience Unlimited players.
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        Seasons Added
      </AccordionSummary>
      <AccordionDetails>
        <Typography align="left" gutterBottom>
          On the stats page and the game search page, I've added a season selector. When selecting a season, your results will be filtered by the latest expansion. This should help in seeing what decks are more relevant expansion by expansion.
        </Typography>
      </AccordionDetails>
    </Accordion>
  </>
);

export default Updates;
